import styled from 'styled-components';

const AnswerText = styled.div`
  text-align: left;

  h1 {
    font-size: 1.05rem;
  }

  h2 {
    font-size: 1rem;
  }

  h3,
  h4,
  h5,
  h6 {
    font-size: 0.95rem;
  }

  img {
    display: block;
    margin: 20px auto;
    max-width: 100%;
  }

  ul {
    padding-left: 25px;
  }

  p {
    white-space: pre-line;
  }

  p:last-child {
    margin-bottom: 0;
  }

  .mod--smartForm .bot & {
    color: #000;
    font-size: 16px;
    font-weight: 300;
  }
`;

// eslint-disable-next-line import/prefer-default-export
export { AnswerText };
